import styled from 'styled-components';
import { Popup } from 'react-map-gl';
import {
  ClearButton,
  TripButton as BaseTripButton,
} from '#/shared/components/Styled';
import SelectedLocationMarker from '#/shared/components/GeneratedIcons/trimet/SelectedLocationMarker';
import SvgMap from '#/shared/components/GeneratedIcons/trimet/TripPlannerSolid';
import { CurrentLocationMarker as BaseCurrentLocationMarker } from '#/map/components/CurrentLocationOverlay';

export const ContextMenuWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  width: 200px;
`;

export const ContextMenuRow = styled(ClearButton)`
  display: flex;
  align-items: center;
  padding: 8px 5px;
  width: 100%;
  color: ${props => props.theme.mainColor};
  border-radius: ${props => props.theme.buttonRadius};
  margin: 0 0 7px 0;
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

export const IconColumn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 21px;
  width: 16px;
  margin: 0 5px;
`;

export const ContentColumn = styled.div`
  width: 75%;
  font-size: 1.1em;
  text-align: left;
`;

export const SelectedLocationIcon = styled(SelectedLocationMarker).attrs({
  width: 25,
  height: 25,
  title: 'Selected Location',
})``;

export const MapIcon = styled(SvgMap).attrs(props => ({
  width: 16,
  height: 16,
  title: 'Map',
  fill: props.theme.mainColor,
}))``;

export const PlanTripRowWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  margin: 10px 0 0;
  flex-wrap: normal;
  align-items: stretch;
  align-content: stretch;
`;

export const TripButton = styled(BaseTripButton)`
  text-align: center;
  padding: 5px;
  border-radius: ${props => props.theme.buttonRadius};
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.mainColor};
  background-color: ${props => props.theme.inverseSecondaryButtonBgColor};
  border: 0;
  margin: 0;

  @media (any-hover: hover) {
    &:hover {
      background-color: ${props =>
        props.theme.inverseSecondaryButtonBgColorHover};
      color: ${props => props.theme.mainColor};
    }
  }

  &:focus,
  &:active {
    background-color: ${props => props.theme.inverseSecondaryButtonBgColor};
  }
`;

export const Separator = styled.div`
  flex: 0 1 5px;
`;

export const CurrentLocationMarker = styled(BaseCurrentLocationMarker).attrs({
  size: 13,
  pulsate: false,
})``;

export const ClearCurrentLocationMarker = styled(CurrentLocationMarker).attrs(
  ({ theme }) => ({
    color: theme.clearCurrentPositionColor,
  })
)``;

export const MapGlPopup = styled(Popup)`
  div.maplibregl-popup-content {
    border-radius: 12px;
    padding: 19px 11px;
  }
  button.maplibregl-popup-close-button {
    color: ${props => props.theme.contextMenuButtonColor};
    &:hover {
      background-color: unset;
      color: ${props => props.theme.contextMenuButtonHoverColor};
    }
    font: 16px/14px Tahoma, Verdana, sans-serif;
    font-weight: 700;
    height: 14px;
    padding: 6px 6px 0px 0px;
    width: 16px;
    margin-right: 0.25rem;
  }
`;
